export default __webpack_public_path__ + "static/media/M11.edf79013.svg";